<template>
  <div class="interaction-body display-minimum check-all-that-apply check-all-that-apply-display-minimum">
    <div
      class="check-all-that-apply-option playposit-answer mb-1 pa-1"
      :key="io.id"
      v-for="io in localInteraction.interactionOptions"
    >
      <v-checkbox
        class="mt-0"
        :ripple="false"
        readonly
        hide-details
      >
        <div
          slot="label"
          class="pp-interaction-body"
          v-html="io.option"
        ></div>
      </v-checkbox>
      <InteractionAttachments :attachments="io.interactionOptionAttachments" />
    </div>
  </div>
</template>

<script>
import InteractionAttachments from '../../Snippets/InteractionAttachments.vue';
import Interaction from '../../../mixins/Interaction';

export default {
  name: 'CheckAllThatApplyDisplayMinimumInteractionBody',
  components: {
    InteractionAttachments,
  },
  mixins: [
    Interaction,
  ],
};
</script>